import { render, staticRenderFns } from "./DSForm.vue?vue&type=template&id=3bae4f83&scoped=true&"
import script from "./DSForm.vue?vue&type=script&lang=js&"
export * from "./DSForm.vue?vue&type=script&lang=js&"
import style0 from "./DSForm.vue?vue&type=style&index=0&id=3bae4f83&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae4f83",
  null
  
)

export default component.exports